<form [formGroup]="form">
  <mat-form-field class="example-full-width " appearance="outline" (click)="edit(data)" (focus)="edit(data);"
    tabindex="0">
    <mat-label (click)="edit(value)">{{label}}</mat-label>
    <ng-container *ngIf="!isTextArea">
      <input #inlineEditControl matInput [type]="type" [placeholder]="label" formControlName="inlineControl"
        (blur)="onBlur($event)" />
    </ng-container>
    <ng-container *ngIf="isTextArea">
      <textarea matInput #inlineEditControl matInput [type]="type" [placeholder]="label" formControlName="inlineControl"
        (blur)="onBlur($event)"></textarea>
    </ng-container>
    <div *ngIf="form.get('inlineControl').invalid &&
                form.get('inlineControl').errors &&
                (form.get('inlineControl').dirty || form.get('inlineControl').touched)">
      <small class="text-danger" *ngIf="form.get('inlineControl').hasError('required')">
        This field is required.
      </small>
      <small class="text-danger" *ngIf="form.get('inlineControl').hasError('minlength')">
        The minimum length for this field is {{form.get('inlineControl').errors.minlength.requiredLength}}
        characters.
      </small>
      <small class="text-danger" *ngIf="form.get('inlineControl').hasError('maxlength')">
        The maximum length for this field is {{form.get('inlineControl').errors.maxlength.requiredLength}}
        characters.
      </small>
    </div>
  </mat-form-field>
</form>
